import React, { Fragment } from 'react'
import { twMerge as twm } from 'tailwind-merge'

import Button from './Button'
import Heading from './Heading'
import Label from './Label'

type CardProps = React.ComponentPropsWithoutRef<'div'> & {
    size?: 'xl' | 'lg' | 'md' | 'sm'
    title?: string
    count?: number
    headerButtons?: { title: string; onClick: () => void }[]
}

const Card = ({
    children,
    className,
    size = 'xl',
    title,
    count,
    headerButtons,
    ...props
}: CardProps) => {
    const sizeClasses = {
        xl: 'max-w-xlarge',
        lg: 'max-w-large',
        md: 'max-w-medium',
        sm: 'max-w-small',
    }

    return (
        <div
            {...props}
            className={twm(
                'w-full rounded-lg bg-white',
                size === 'sm' ? 'p-6' : 'p-8',
                sizeClasses[size],
                className
            )}
            data-testid="card-wrapper"
        >
            {(title !== undefined || headerButtons !== undefined) && (
                <div className="flex items-center justify-between">
                    {title !== undefined ? (
                        <Heading size={size === 'sm' ? 'xs' : 'sm'} className="text-gray-700">
                            {title}{' '}
                            {count !== undefined && (
                                <Label size="md" className="text-gray-600">
                                    ({count})
                                </Label>
                            )}
                        </Heading>
                    ) : (
                        <div />
                    )}

                    {headerButtons !== undefined && (
                        <div className="flex items-center justify-center gap-x-4">
                            {headerButtons.map((headerButton, headerButtonIndex) => (
                                <Fragment key={headerButton.title}>
                                    <Button
                                        intent="tertiary"
                                        onClick={headerButton.onClick}
                                        size="small"
                                    >
                                        {headerButton.title}
                                    </Button>

                                    {headerButtonIndex < headerButtons.length - 1 && (
                                        <div className="h-4 w-px bg-gray-300" />
                                    )}
                                </Fragment>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {children}
        </div>
    )
}

export default Card
